import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import FeatureFlagProvider from './featureFlags/FeatureFlagProvider';

// FeatureFlagProvider wraps the whole app so one evaluation serves every view.
// It renders on code defaults immediately, so it adds no gate of its own and
// cannot delay a supporter reaching the form — see FeatureFlagProvider.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <FeatureFlagProvider>
      <App />
    </FeatureFlagProvider>
  </StrictMode>,
);
